var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a, _b;
import React, { useCallback, useEffect, useRef } from 'react';
import { Portal } from 'react-portal';
import { registerClass, cns, registerGlobal, getContext, } from '@food/css-manager';
import { canUseDOM } from 'exenv';
// style
var style = registerClass(function (t) { return "\n\tposition: absolute;\n\tmax-width: 100%;\n\tz-index: " + t.zIndexes.P2_AreaAbove + ";\n\t// overflow: hidden; // Devo poterlo sfondare se necessario o anche gestire lo scroll\n"; }, false);
// Necessario perché il posizionamento absolute è rispetto al body
registerGlobal(function () { return "position: relative;"; });
export var DropdownPositions;
(function (DropdownPositions) {
    DropdownPositions["Above"] = "Above";
    DropdownPositions["Below"] = "Below";
})(DropdownPositions || (DropdownPositions = {}));
var DropdownPositionChecks = (_a = {},
    _a[DropdownPositions.Above] = function (rect, internalHeight, windowH) {
        return rect.top > internalHeight ? rect.top : false;
    },
    _a[DropdownPositions.Below] = function (rect, internalHeight, windowH) {
        return windowH - rect.bottom > internalHeight
            ? windowH - rect.bottom
            : false;
    },
    _a);
export var DropdownAlignments;
(function (DropdownAlignments) {
    DropdownAlignments["Start"] = "Start";
    // Middle = 'Middle',
    DropdownAlignments["End"] = "End";
})(DropdownAlignments || (DropdownAlignments = {}));
var DropdownAlignmentChecks = (_b = {},
    _b[DropdownAlignments.Start] = function (rect, internalWidth, windowW) {
        return windowW - rect.left > internalWidth ? windowW - rect.left : false;
    },
    _b[DropdownAlignments.End] = function (rect, internalWidth, windowW) {
        return rect.right > internalWidth ? rect.right : false;
    },
    _b);
var handleNativeElemPosition = function (element, internalNode, preferredPosition, preferredAlignment) {
    // Misuro tutto
    var bodyClientRect = document.body.getBoundingClientRect();
    var bodyStyle = window.getComputedStyle(document.body);
    var bodyRect = {
        left: bodyClientRect.left - parseFloat(bodyStyle.marginLeft),
        top: bodyClientRect.top - parseFloat(bodyStyle.marginTop),
        right: bodyClientRect.right + parseFloat(bodyStyle.marginRight),
        bottom: bodyClientRect.bottom + parseFloat(bodyStyle.marginBottom)
    };
    var rect = element.getBoundingClientRect();
    var windowH = window.innerHeight;
    var windowW = window.innerWidth;
    // Nascondo in modo da non avere sfarfallii, ma da poterlo comunque misurare
    internalNode.style.visibility = 'hidden';
    // Reset internalNode style
    internalNode.style.maxHeight = '';
    internalNode.style.top = '';
    internalNode.style.right = '';
    internalNode.style.bottom = '';
    internalNode.style.left = '';
    internalNode.style.display = 'block'; // Così si misura correttamente
    internalNode.style.minWidth = rect.right - rect.left + "px"; // Almeno largo come il componente da cui scende
    // Decido dove posizionarlo con che dimensioni massime
    var internalHeight = internalNode.clientHeight;
    var position = __spreadArrays([
        preferredPosition
    ], Object.keys(DropdownPositions).filter(function (p) { return p !== preferredPosition; })).find(function (p) { return DropdownPositionChecks[p](rect, internalHeight, windowH); });
    if (position) {
        internalNode.style.maxHeight = DropdownPositionChecks[position](rect, internalHeight, windowH) + "px";
    }
    else {
        // Devo stringerlo e lo metto dove c'è più spazio
        if (windowH - rect.bottom >= rect.top) {
            position = DropdownPositions.Below;
            internalHeight = windowH - rect.bottom;
        }
        else {
            position = DropdownPositions.Above;
            internalHeight = rect.top;
        }
        internalNode.style.maxHeight = internalHeight + "px";
    }
    // Decido dove allinearlo con che dimensioni massime
    var internalWidth = internalNode.clientWidth;
    var alignment = __spreadArrays([
        preferredAlignment
    ], Object.keys(DropdownAlignments).filter(function (a) { return a !== preferredAlignment; })).find(function (a) { return DropdownAlignmentChecks[a](rect, internalWidth, windowW); });
    if (alignment) {
        internalNode.style.maxWidth = DropdownAlignmentChecks[alignment](rect, internalWidth, windowW) + "px";
    }
    else {
        // Devo stringerlo e lo metto dove c'è più spazio
        if (windowW - rect.left >= rect.right) {
            alignment = DropdownAlignments.Start;
            internalWidth = windowW - rect.left;
        }
        else {
            alignment = DropdownAlignments.End;
            internalWidth = rect.right;
        }
        internalNode.style.maxWidth = internalWidth + "px";
    }
    // Lo posiziono
    switch (position) {
        case DropdownPositions.Above:
            internalNode.style.bottom = bodyRect.bottom -
                Math.min(rect.top, windowH) + "px";
            break;
        case DropdownPositions.Below:
            internalNode.style.top = Math.max(rect.bottom, 0) -
                bodyRect.top + "px";
            break;
    }
    switch (alignment) {
        case DropdownAlignments.Start:
            internalNode.style.left = Math.max(rect.left, 0) -
                bodyRect.left + "px";
            break;
        case DropdownAlignments.End:
            internalNode.style.right = Math.max(windowW - rect.right, 0) -
                (windowW - bodyRect.right) + "px";
            break;
    }
    // Mostra ora in modo da non avere sfarfallii
    internalNode.style.visibility = 'visible';
};
export var Dropdown = function (_a) {
    var element = _a.element, open = _a.open, _b = _a.preferredPosition, preferredPosition = _b === void 0 ? DropdownPositions.Below : _b, _c = _a.preferredAlignment, preferredAlignment = _c === void 0 ? DropdownAlignments.Start : _c, className = _a.className, onClickOutside = _a.onClickOutside, children = _a.children;
    var internalRef = useRef();
    var handlePosition = useCallback(function () {
        var internalNode = internalRef.current;
        // nessuna gestione nel rendering server side o quando il componente e' smontato
        if (!canUseDOM || !internalNode) {
            return;
        }
        handleNativeElemPosition(element.current, internalNode, preferredPosition, preferredAlignment);
    }, [open, element]);
    useEffect(function () {
        if (open) {
            handlePosition();
            var outsideHandler_1 = function (e) {
                if (internalRef.current &&
                    // @ts-ignore
                    !internalRef.current.contains(e.target) &&
                    onClickOutside !== undefined) {
                    if (element.current && element.current.contains(e.target)) {
                        e.stopPropagation();
                    }
                    onClickOutside(e);
                }
            };
            window.addEventListener('scroll', handlePosition);
            document.addEventListener('click', outsideHandler_1, true);
            return function () {
                document.removeEventListener('click', outsideHandler_1, true);
                window.removeEventListener('scroll', handlePosition);
            };
        }
        return function () { };
    }, [open]);
    var cssContext = getContext();
    return (React.createElement(Portal, null,
        React.createElement("div", { className: cns.apply(void 0, __spreadArrays([className, style], (cssContext.portalClasses || []))), ref: internalRef, style: {
                visibility: 'hidden',
                display: open ? 'block' : 'none',
            } }, children)));
};
//# sourceMappingURL=Dropdown.js.map